module.exports = __webpack_public_path__ + "static/media/recharge-3.ba5dfd4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/slider/recharge-3.jpg
// module id = 613
// module chunks = 6